import React, { useState } from 'react';
import './WordBuild.css';

const API_URL = 'https://api.dictionaryapi.dev/api/v2/entries/en';

const WordBuild = () => {
  const [selectedLetters, setSelectedLetters] = useState([]);
  const [createdWord, setCreatedWord] = useState('');
  const [score, setScore] = useState(0);
  const [wordMeaning, setWordMeaning] = useState('');

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleLetterClick = (letter) => {
    setSelectedLetters([...selectedLetters, letter]);
    setCreatedWord(selectedLetters.join('') + letter);
  };

  const handleVerifyWord = async () => {
    const response = await fetch(`${API_URL}/${createdWord.toLowerCase()}`);
    const data = await response.json();
    if (response.ok) {
      setScore(score + 1);
      alert('Correct!');
    } else {
      alert('Incorrect!');
    }
  };

  const handleClear = () => {
    setSelectedLetters([]);
    setCreatedWord('');
    setWordMeaning('');
  };

  const handleNextWord = () => {
    setSelectedLetters([]);
    setCreatedWord('');
    setWordMeaning('');
  };

  const handleGetMeaning = async () => {
    const response = await fetch(`${API_URL}/${createdWord.toLowerCase()}`);
    const data = await response.json();
    if (response.ok) {
      setWordMeaning(data[0].meanings[0].definitions[0].definition);
    } else {
      setWordMeaning('No meaning found.');
    }
  };

  return (
    <div className="AppWB">
      <h1>Word Building Game</h1>
      <div className="letter-buttons">
        {letters.map((letter, index) => (
          <button key={index} onClick={() => handleLetterClick(letter)}>
            {letter}
          </button>
        ))}
      </div>
      <div className="controls">
        <button onClick={handleClear}>Clear Board</button>
        <button onClick={handleNextWord}>Next Word</button>
        <button onClick={handleVerifyWord}>Verify Word to Score</button>
        <button onClick={handleGetMeaning}>Meaning of Word</button>
      </div>
      <div className="created-word">
        <h2>Created Word: {createdWord}</h2>
      </div>
      <div className="score1">
        <h2>Score: {score}</h2>
      </div>
      <div className="word-meaning">
        <h2>Meaning: {wordMeaning}</h2>
      </div>
    </div>
  );
};

export default WordBuild;
